// directives/permission.js
import { DirectiveBinding } from 'vue';
import Cookies from 'js-cookie';

// 自定义指令
export default {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    const { value } = binding;
    const userInfo = JSON.parse(Cookies.get('userInfo') || '{}');
    const permissions = userInfo?.permissions.split(',') || [];

    if (permissions) {
      if (Array.isArray(value)) {
        if (value.length > 0) {
          const permissionRoles = value;
          const hasPermission = permissions.some((role: string) => {
            if (role === 'all') return true;
            return permissionRoles.includes(role);
          });
          if (!hasPermission) {
            el.parentNode?.removeChild(el);
          }
        }
      }
    }
  }
};

export function checkPermission(value: string[]) {
  const userInfo = JSON.parse(Cookies.get('userInfo') || '{}');
  const permissions = userInfo?.permissions;
  if (permissions) {
    if (Array.isArray(value)) {
      if (value.length > 0) {
        const permissionRoles = value;
        const hasPermission = permissions.some((role: string) => {
          return permissionRoles.includes(role);
        });
      }
    }
  }
}
